module.exports = __webpack_public_path__ + "static/media/bills.94f8411f.png";